import createVueComponent from '../createVueComponent';

const ArrowLeftToLine = createVueComponent('ArrowLeftToLineIcon', [
  ['path', { d: 'M3 19V5', key: 'rwsyhb' }],
  ['path', { d: 'm13 6-6 6 6 6', key: '1yhaz7' }],
  ['path', { d: 'M7 12h14', key: 'uoisry' }],
]);

export default ArrowLeftToLine;
